import { useEffect } from 'react';

export const useCookiehubScriptLoader = () => {
  useEffect(() => {
    try {
      const script1 = document.createElement('script');
      script1.src = 'https://cdn.cookiehub.eu/gpp/v3/stub.js';
      script1.async = true;

      const script2 = document.createElement('script');
      script2.src = 'https://cdn.cookiehub.eu/c2/9e34cde0.js';
      script2.async = true;

      script2.onload = () => {
        const cpm = {};
        if ((window as any).cookiehub) {
          (window as any).cookiehub.load(cpm);
        } else {
          console.warn('CookieHub not loaded');
        }
      };

      document.body.appendChild(script1);
      document.body.appendChild(script2);

      return () => {
        document.body.removeChild(script1);
        document.body.removeChild(script2);
      };
    } catch (err) {
      console.error('Error in useCookiehubScriptLoader useEffect:', err);
    }
  }, []);
};
